import * as contentful from "contentful"

export const client = contentful.createClient({
    space: "dtcnvmzrptg2",
    accessToken: "Ts0B_g2fbfwXmowK9aJiJ5WDZvyoiIjfLEtf9A4r648"
})